<template>
  <el-row class="right-top">
    <div>
      <div v-if="organizations && organizations.length > 1" class="top-ban">
        <div style="display: flex;"> 
          <div style="padding: 5px;font-weight: bold;border: solid 1px #d1d1d1;border-right: 0px;">
            员工服务平台
          </div>
          <img :src="HornRightGrey" alt="" style="height: 100%;" > 
        </div>
        <div class="org-select">
           <img :src="HornRightBlue" alt="" style="height: 100%;">
           <div class="select-div">
              <el-select class="org-change-select"  v-model="currOrgIndex" @change="currOrgChange" :style="widthStyle">
                <el-option  v-for="(o, index) in organizations" :key="index" :label="o.fullName" :value="index">
                  <div style="display: flex;">
                    <div style="padding-top: 3px;padding-right: 5px;"><el-icon><office-building /></el-icon></div>
                    <div>{{ o.fullName }}</div>
                  </div>
                </el-option>
              </el-select> 
           </div>
        </div>
        <div>
          <img :src="HornRightBlue" alt="" style="height: 100%;" >
        </div>
      </div>
    </div>
    <div style="padding-right: 20px;">
      <el-popover placement="bottom" :width="60" trigger="hover">
        <template #reference>
          <el-row type="flex" class="user-op">
            <el-avatar v-if="photoPath" :size="27" :src="photoPath"></el-avatar>
            <el-avatar v-else :size="27" icon="avatar"></el-avatar>
            <span>{{userName}}</span>
          </el-row>
        </template>
        <div>
          <div><el-button type="text" icon="edit" @click="$refs.updatePass.show()">修改密码</el-button></div>
          <div><el-button type="text" icon="circle-close-filled" @click="toLogOut">退出登陆</el-button></div>
        </div>
      </el-popover>
    </div>
  </el-row>

  <update-pass ref="updatePass" />
</template>

<script>
import { defineComponent } from 'vue'
import { mapGetters, mapActions, mapMutations } from 'vuex';
import { loginOut } from '@/api/login'
import UpdatePass from './UpdatePass.vue'
import { switchOrgOrSys } from '@/api';
import HornRightGrey from '@/assets/icon/index/horn-right-grey.png';
import HornRightBlue from '@/assets/icon/index/horn-right-blue.png';
export default defineComponent({
  components: { UpdatePass },
  emits: ['change-collapse'],
  computed: {
    ...mapGetters(['userName', 'photoPath', 'isSys', 'orgId', 'organizations'])
  },
  data() {
    return {
      HornRightGrey,HornRightBlue,
      currOrgIndex: 0,
      widthStyle:'width:100%'
    }
  },
  methods: {
    ...mapMutations(['switchOrgSetUser', 'removeAllNotRoutes']),
    ...mapActions(['removeAll']),
    toLogOut() {
      this.$confirm('确认退出登陆', '提示').then(_ => {
        loginOut().then(({data}) => {
          if (data.status === true) {
            this.removeAll()
            this.$router.push('/login');
          } else {
            this.$message.error("注销失败");
          }
        }).catch(_ => {})
      }).catch(_ => {})
    },
    setCurrOrgIndex() { // 设置当前的企业
      if (!this.organizations || !this.organizations.length) {
        return;
      }
      let index;
      if (this.isSys === true || this.isSys === 'true') {
        index = this.organizations.findIndex(o => o.type == 'SYS');
      } else if (this.orgId) {
        index = this.organizations.findIndex(o => o.type == 'ORG' && o.id == this.orgId);
      } else {
        index = this.organizations.findIndex(o => o.type == 'PROJECT');
      }
      this.currOrgIndex = (Number.isInteger(index) && index < 0) ? null : index;
      this.getOrgWidth();
    },
    currOrgChange(orgIndex) { // 当前企业切换
      if (this.isSys && this.organizations[orgIndex].type === 'SYS') {
        return;
      }
      if (this.orgId && this.organizations[orgIndex].id === this.orgId) {
        return;
      }
      switchOrgOrSys(this.organizations[orgIndex]).then(({data}) => {
        if (data.status) {
          this.switchOrgSetUser(data.data);
          this.removeAllNotRoutes();
          this.$message.success(data.msg);
          this.$router.push({
            path: '/blank',
            query: {path: this.$route.path}
          });
        } else {
          this.$message.warning(data.msg);
        }
      })
    },
    getOrgWidth(){
      let fullName = this.organizations[this.currOrgIndex].fullName;
      let length= fullName.length *16.6
      this.widthStyle= "width:"+length+"px";
    }
  },
  watch: {
    organizations: {
      handler(val) {
        this.setCurrOrgIndex();
      },
      deep: true
    },
    isSys(val) {
      this.setCurrOrgIndex();
    },
    orgId(val) {
      this.setCurrOrgIndex();
    }
    
  },
  mounted() {
    this.setCurrOrgIndex();
  }
})
</script>

<style lang="scss" scoped>
.right-top {
  padding-left: 5px;
  height: 60px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .top-ban{
      display: flex;
      height: 35px;
      .org-select{
          display: flex;
          border-top: solid 1px #0F74F0;
          border-bottom: solid 1px #0F74F0;
      }
      .select-div{
        padding: 5px 0px;
        padding-left: 5px;
      }
  }
 
  
}
</style>
<style lang="scss" >
.org-change-select{
  width: 100%;
  margin-right: 5px;
  .el-input__inner{
      border: 0px;
      font-weight: bold;
      border-radius: 0;
      //border-bottom: 2px solid #007cfb;
      line-height: 0px;
      height: auto;
      padding: 0px;
      padding-right: 16px;
      background-color: #ffffff;
      color: #0F74F0;
    }
  .el-input__suffix{
    right: 3px;
    .el-input__suffix-inner{
      .el-select__caret{
        color: #0f74f0;
        font-size: 16px;
      }
    }
  }
  .el-select-dropdown__item{
    padding: 0px;
  }
}

</style>